module.exports = __webpack_public_path__ + "static/media/pet_lvl2.05cf4b5b.png";